import type { ILink } from "./fetchLink"

type LinkDestination = Pick<ILink, "destination" | "spaceId" | "spaceid">

export const getLinkBaseUrl = (
  linkHost: string,
  currentProtocol: string,
): string => {
  if (linkHost.startsWith("http://") || linkHost.startsWith("https://")) {
    return linkHost
  }

  return `${currentProtocol}//${linkHost}`
}

export const getLinkSpaceId = (
  link: Pick<ILink, "spaceId" | "spaceid">,
): string | undefined => {
  return link.spaceId || link.spaceid
}

export const resolveLinkDestination = (
  link: LinkDestination,
  linkHost: string,
  currentProtocol: string,
) => {
  let destination = link.destination

  if (destination.includes("/projects/")) {
    destination = destination.replace("/projects/", "/proposal/")
  }

  let url = destination
  if (!destination || !destination.startsWith("http")) {
    url = new URL(
      destination || "/",
      getLinkBaseUrl(linkHost, currentProtocol),
    ).toString()
  }

  const { host, pathname, protocol, search } = new URL(url)
  const searchParams = new URLSearchParams(search)
  const linkSpaceId = getLinkSpaceId(link)

  if (linkSpaceId && !searchParams.has("spaceId")) {
    searchParams.set("spaceId", linkSpaceId)
  }

  const formattedQueryString = searchParams.toString()
  const destinationPath = `${pathname}${
    formattedQueryString.length > 0 ? `?${formattedQueryString}` : ""
  }`

  return {
    destinationPath,
    destinationUrl: `${protocol}//${host}${destinationPath}`,
    host,
  }
}
